import React, { useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { QRCodeCanvas } from "qrcode.react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaFilePdf, FaSync, FaTrash, FaArrowRight, FaStar, FaExclamationCircle, FaLightbulb } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

export default function GenerateUIDPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [count, setCount] = useState(2);
    const [generatedData, setGeneratedData] = useState([]);
    const [isExporting, setIsExporting] = useState(false);

    // المرجع الخاص بالتصدير فقط
    const exportRef = useRef();

    const baseUrl = "https://custpro.org/";

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const passedUid = params.get("uid") || location.state?.uid;
        if (passedUid) {
            setGeneratedData([{ id: passedUid, url: `${baseUrl}${passedUid}` }]);
            setCount(1);
        }
    }, [location]);

    const handleGenerate = () => {
        const newData = [];
        for (let i = 0; i < count; i++) {
            const uid = uuidv4();
            newData.push({ id: uid, url: `${baseUrl}${uid}` });
        }
        setGeneratedData(newData);
    };

    const exportPDF = async () => {
        setIsExporting(true);
        // ننتظر قليلاً لضمان رندر العناصر المخفية
        await new Promise(r => setTimeout(r, 600));

        const pdf = new jsPDF("p", "mm", "a4");
        const pages = exportRef.current.querySelectorAll(".print-page");

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], {
                scale: 2,
                useCORS: true,
                logging: false,
                windowWidth: 1200 // ثبات العرض أثناء التصوير لمنع تأثر الجوال
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.9);
            if (i > 0) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
        }

        pdf.save("Custpro_Cards.pdf");
        setIsExporting(false);
    };

    // المكون الأصلي (مقدس لا يتغير)
    const OriginalCardDesign = ({ item, showLine }) => (
        <div style={cardStyle}>
            <div style={innerContainer}>
                <div style={rightSide}>
                    <h1 style={titleStyle}>حماية المستهلك وسلامة الغذاء</h1>
                    <p style={descStyle}>ساهم معنا في رفع جودة الخدمة من خلال مسح الرمز ومن ثم :</p>
                    <div style={listStyle}>
                        <div style={listItem}><FaStar color="#f59e0b" size={20} /> <span>تقييم مستوى الخدمة</span></div>
                        <div style={listItem}><FaLightbulb color="#3b82f6" size={20} /> <span>مشاركتنا مقترحاتك</span></div>
                        <div style={listItem}><FaExclamationCircle color="#ef4444" size={20} /> <span>تقديم شكوى مباشرة</span></div>
                    </div>
                    <div style={{ marginTop: '25px', fontSize: '18px', color: '#3112a1ff', fontWeight: 'bold' }}>
                        وفي حال تعذر مسح الرمز يمكنك الذهاب ل : https://custpro.org
                    </div>
                </div>
                <div style={leftSide}>
                    <div style={qrBox}>
                        <QRCodeCanvas value={item.url} size={180} level={"H"} />
                        <p style={{ marginTop: '10px', fontSize: '12px', fontWeight: 'bold', color: '#555' }}>امسح هنا (SCAN)</p>
                    </div>
                </div>
            </div>
            {showLine && <div style={cutDashedLine}></div>}
        </div>
    );

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl" style={{ overflowX: 'hidden' }}>
            {/* واجهة التحكم */}
            <div className="container shadow-sm bg-white rounded-4 p-4 d-print-none mb-4">
                <div className="row g-3 align-items-center">
                    <div className="col-12 col-md-6">
                        <h3 className="fw-bold m-0 text-dark">توليد بطاقات QR</h3>
                        <p className="text-muted small mb-0">المعاينة متجاوبة والتصدير بجودة ثابتة</p>
                    </div>
                    <div className="col-12 col-md-6 d-flex gap-2 justify-content-md-end">
                        <button onClick={exportPDF} className="btn btn-danger rounded-pill px-4 shadow-sm" disabled={isExporting}>
                            {isExporting ? "جاري التصدير..." : "تصدير PDF"}
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">رجوع</button>
                    </div>
                </div>
                <div className="row g-2 mt-3">
                    <div className="col-4"><input type="number" className="form-control rounded-3" value={count} onChange={(e) => setCount(Number(e.target.value))} /></div>
                    <div className="col-4"><button onClick={handleGenerate} className="btn btn-primary w-100 rounded-3">توليد</button></div>
                    <div className="col-4"><button onClick={() => setGeneratedData([])} className="btn btn-outline-danger w-100 rounded-3">حذف</button></div>
                </div>
            </div>

            {/* المعاينة للمستخدم */}
            <div className="container px-2 d-print-none">
                <div className="row g-4">
                    {generatedData.map((item, idx) => (
                        <div key={idx} className="col-12 col-xl-6">
                            <div className="preview-wrap">
                                <OriginalCardDesign item={item} showLine={false} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* الحاوية المخفية السحرية (معزولة تماماً لمنع قفز السايدبار) */}
            <div style={{ position: 'fixed', left: '-10000px', top: 0, width: '210mm', pointerEvents: 'none', zIndex: -1 }}>
                <div ref={exportRef}>
                    {Array.from({ length: Math.ceil(generatedData.length / 2) }).map((_, pageIndex) => (
                        <div key={pageIndex} className="print-page" style={pageContainerStyle}>
                            {generatedData.slice(pageIndex * 2, pageIndex * 2 + 2).map((item, idx) => (
                                <OriginalCardDesign key={idx} item={item} showLine={idx === 0} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
                .preview-wrap { 
                    background: white; 
                    border-radius: 15px; 
                    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
                    transform-origin: top right;
                    zoom: 0.5; /* التصغير البصري فقط */
                }
                @media (max-width: 576px) { .preview-wrap { zoom: 0.33; } }
                @media (min-width: 1200px) { .preview-wrap { zoom: 0.7; } }
            `}</style>
        </div>
    );
}

// التنسيقات الثابتة الأصلية
const pageContainerStyle = { width: "210mm", height: "297mm", backgroundColor: "#fff", display: "flex", flexDirection: "column", position: "relative", direction: "rtl" };
const cardStyle = { height: "148.5mm", width: "100%", padding: "15mm 10mm", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxSizing: "border-box" };
const innerContainer = { width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", border: "2px solid #222", borderRadius: "15px", padding: "25px", height: "100%", boxSizing: "border-box" };
const rightSide = { flex: "0 0 65%", textAlign: "right", display: "flex", flexDirection: "column", justifyContent: "center" };
const leftSide = { flex: "0 0 35%", display: "flex", justifyContent: "center", alignItems: "center" };
const titleStyle = { fontSize: "38px", fontWeight: "900", color: "#000", margin: "0 0 10px 0", lineHeight: "1.2" };
const descStyle = { fontSize: "20px", color: "#444", lineHeight: "1.4", marginBottom: "25px" };
const listStyle = { display: "flex", flexDirection: "column", gap: "12px" };
const listItem = { display: "flex", alignItems: "center", gap: "10px", fontSize: "20px", fontWeight: "bold", color: "#333" };
const qrBox = { padding: "15px", backgroundColor: "#fff", border: "1px solid #ddd", borderRadius: "12px", textAlign: "center" };
const cutDashedLine = { position: "absolute", bottom: "0", left: "5%", right: "5%", borderBottom: "1px dashed #bbb" };